import { isLocalEnv } from 'utils/env';

export const log = (...msg: any) => console.log('[app] --->', ...msg);

export const delay = (ms: number) => new Promise((res) => setTimeout(res, ms));

export const localDebug = (...msg: any) => {
  if (isLocalEnv()) console.log('[localDebug]', ...msg);
};
